import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";

import { formatOfferDateTime, isProposalFromTrader } from "../../../utils";
import { MessageBubble } from "../MessageBubble";
import { NegotiationProposal } from "../NegotiatedDetailsCard/offer-negotiation-proposal";

interface ProposalCommentProps {
  proposal: NegotiationProposal;
  round: number;
}

export const ProposalComment = ({ proposal, round }: ProposalCommentProps) => {
  const { t } = useTranslation();
  const own = isProposalFromTrader(proposal);

  return (
    <MessageBubble
      own={own}
      userName={`${proposal.user?.first_name} ${proposal.user?.last_name}`}
      dateTime={formatOfferDateTime(proposal.backend_creation_time)}
      badge={
        <Badge variant={own ? "default" : "warning"}>
          {t("termsComparison.counterRound", { round })}
        </Badge>
      }
    >
      <div className="mt-2 flex flex-wrap gap-1 text-foreground text-sm">
        <span>{proposal.text}</span>
      </div>
    </MessageBubble>
  );
};
